// extracted by mini-css-extract-plugin
export default {"cls1":"VEvygd7Dlf2WpOIPSqEM","cls2":"eJnpIffi45GW4NsaKtux VEvygd7Dlf2WpOIPSqEM"};